import { render } from "./login.vue?vue&type=template&id=7b1e06fb"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=7b1e06fb&lang=css"

import exportComponent from "/vercel/path0/duolango-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__